import Grid from '@mui/material/Unstable_Grid2/Grid2'
import React, { useContext, useEffect, useState } from "react"
import Camera from '../Camera/Camera'
import {
    CameraPrincipalSx,
    cameraSecundariaSx,
    CamerasSecundariasSx
} from './GridCamerasSx'
import { EventosContext } from '../../../Providers/EventosContext/EventosContext'
import { CondominiosContext } from '../../../Providers/CondominiosContext/CondominiosContext'

export default function GridCameras() {
    const { eventoSelecionado } = useContext(EventosContext)
    const { activeCond } = useContext(CondominiosContext)

    const { cameras: camerasEvento } = eventoSelecionado
    const { cameras: camerasCondo, cameras_benuvem } = activeCond

    const [mainCamera, setMainCamera] = useState({})
    const [secondaryCameras, setSecondaryCameras] = useState([{}, {}, {}])

    useEffect(() => {
        let cameras = defineCameras(camerasEvento, camerasCondo)

        if (cameras_benuvem && cameras_benuvem.length > 0) {
            cameras.forEach(cam => {
                const cam_benuvem = cameras_benuvem.find(cam_benuv =>
                    cam_benuv.channel === cam.camera
                )

                if (cam_benuvem) {
                    cam.url = cam_benuvem.live_url
                    cam.snapshot = cam_benuvem.snapshot
                }
            })
        }

        if (cameras) {
            setMainCamera(cameras[0])
            setSecondaryCameras(cameras)
        } else {
            setMainCamera({})
            setSecondaryCameras([{}, {}, {}])
        }
    }, [camerasEvento, camerasCondo])

    const handleChangeMainCamera = (e) => {
        const cameras = defineCameras(camerasEvento, camerasCondo)

        if (cameras) {
            const id = parseInt(e.currentTarget.id)
            setMainCamera(cameras[id])
        }
    }

    return (
        <>
            <Grid lg={8.5} sx={CameraPrincipalSx}>
                <Camera camera={mainCamera} cameraPrincipal={true} />
            </Grid>
            <Grid lg={3.5} sx={CamerasSecundariasSx}>
                {secondaryCameras && secondaryCameras.map((camera, i) => {
                    const selectedCameraSx = {}
                    if (camera.id && (camera.id == mainCamera.id)) {
                        selectedCameraSx.border = '1px solid white'
                    }
                    return (
                        <Grid key={i} id={i} onClick={e => handleChangeMainCamera(e)} sx={{ ...cameraSecundariaSx, ...selectedCameraSx }}>
                            <Camera camera={camera} />
                        </Grid>
                    )
                })}
            </Grid>
        </>
    )
}

const defineCameras = (camerasEvento, camerasCondo) => {
    if (Array.isArray(camerasEvento) && camerasEvento.length > 0) {
        return camerasEvento
    }

    if (Array.isArray(camerasCondo) && camerasCondo.length > 0) {
        return camerasCondo
    }

    return null
}
